import { useState, useEffect } from 'react';
import HttpService from '../../services/HttpService';

/**
 * Custom hook for fetching klanten (customers) with proper state management
 */
const useKlanten = () => {
  const [klanten, setKlanten] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);

  useEffect(() => {
    const fetchKlanten = async () => {
      try {
        // const url = process.env.REACT_APP_API_URL + `/Klanten`;
        // console.log(url);
        
        const httpService = HttpService;
        httpService.configure();
        const axios = httpService.getAxiosClient();
        
        setLoading(true);
        setError(false);

        const response = await axios.get(`/Klanten`);
        setKlanten(response.data);
      } catch (err) {
        console.error("Error fetching klanten:", err);
        setError(true);
        setKlanten(null);
      } finally {
        setLoading(false);
      }
    };

    fetchKlanten();
  }, []);

  return { klanten, loading, error };
};

export default useKlanten;
